var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "compose-box" },
    [
      _c("ybl-num-range", {
        attrs: { unit: _vm.unit, showUnit: true },
        on: { change: _vm.selectChange },
        model: {
          value: _vm.item.defaultVal,
          callback: function($$v) {
            _vm.$set(_vm.item, "defaultVal", $$v)
          },
          expression: "item.defaultVal"
        }
      }),
      _vm._v(" "),
      _c(
        "el-select",
        {
          attrs: { placeholder: "请选择", filterable: true, clearable: "" },
          on: { change: _vm.selectChange },
          model: {
            value: _vm.item.valFlag,
            callback: function($$v) {
              _vm.$set(_vm.item, "valFlag", $$v)
            },
            expression: "item.valFlag"
          }
        },
        _vm._l(_vm.item.valueDictList, function(o) {
          return _c("el-option", {
            key: o.keyCode,
            attrs: { label: o.keyVal, value: o.keyCode }
          })
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-002be2b2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-002be2b2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/compose.vue
// module id = null
// module chunks = 